// Renders a command's tool-call trace, revealing one step at a time.
import React, { useState, useEffect, useRef } from 'react';

export const STEP_MS = 260;

const ToolTrace = ({ steps, onDone }) => {
  const [shown, setShown] = useState(0);
  const doneRef = useRef(false);
  const onDoneRef = useRef(onDone);

  // Keep the latest callback without making it an effect dependency —
  // an inline arrow would otherwise re-fire the effect every render.
  useEffect(() => { onDoneRef.current = onDone; });

  useEffect(() => {
    if (shown >= steps.length) {
      if (!doneRef.current) {
        doneRef.current = true;
        if (onDoneRef.current) onDoneRef.current();
      }
      return undefined;
    }
    const timer = setTimeout(() => setShown((n) => n + 1), STEP_MS);
    return () => clearTimeout(timer);
  }, [shown, steps.length]);

  return (
    <div className="tool-trace">
      {steps.slice(0, shown).map((step, i) => (
        <div key={`${step.tool}-${i}`} className="trace-row-group">
          <div className="trace-row">
            <span className="trace-dot" />
            <span className="trace-tool">{step.tool}</span>
            <span className="trace-args">{step.args}</span>
            <span className="trace-ms">{step.ms} ms</span>
          </div>
          {step.result && (
            <div className="trace-result">└ {step.result}</div>
          )}
        </div>
      ))}
      {shown < steps.length && (
        <div className="trace-row">
          <span className="trace-spinner" />
          <span className="trace-tool">{steps[shown].tool}</span>
          <span className="trace-args">{steps[shown].args}</span>
          <span className="trace-ms">running</span>
        </div>
      )}
    </div>
  );
};

export default ToolTrace;
